import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src="/assets/Images/siddhi-logo.png" alt="Siddhi Wig" />
          <span>Siddhi Wig</span>
        </Link>
        <button className="nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        <div className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <Link
            to="/"
            className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/privacy"
            className={`nav-link ${location.pathname === "/privacy" ? "active" : ""}`}
            onClick={() => setMenuOpen(false)}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </nav>
  );
}
